import React, { ReactNode } from "react";
import { cn, isNullOrUndefined } from "../utils";
import { CellValue, ValueType } from "./dto";
import { round, truncate } from "./utils";

export interface ReadonlyItemProps {
  value?: ReactNode;
  initialValue?: any;
  type?: ValueType;
  attr?: CellValue["attr"];
  placeholder?: string;
  showChanged?: boolean;
}

// 展示只读的单元格
export default function ReadonlyItem({
  value,
  initialValue,
  type,
  attr = {},
  placeholder = "--",
  showChanged = false,
  ...rest
}: ReadonlyItemProps) {
  const changed = initialValue !== value;
  if (isNullOrUndefined(value)) {
    return (
      <span
        className={cn({ "wbuc-text-[#3b65ee]": changed && showChanged })}
        {...rest}
      >
        {placeholder}
      </span>
    );
  }
  const isNumber = type === "number";
  const isImage = type === "image";
  const {
    precision = 4,
    rounding = "round",
    trailingZeroes = false,
    thousandSeparator = false,
    displayMode = "floating",
    width = "auto",
    height = "auto",
  } = attr ?? {};
  if (isImage) {
    if (displayMode === "floating") {
      return (
        <div className="wbuc-relative wbuc-inline-block">
          <img
            className="wbuc-absolute wbuc-left-1/2 wbuc-top-1/2 -wbuc-translate-x-1/2 -wbuc-translate-y-1/2 wbuc-transform wbuc-mix-blend-darken"
            src={value as string}
            style={{
              width,
              height,
            }}
          />
        </div>
      );
    }
    if (displayMode === "embedded") {
      return (
        <img
          className="wbuc-mix-blend-darken"
          src={value as string}
          style={{
            width,
            height,
          }}
        />
      );
    }
  }
  let showValue = value;
  if (isNumber) {
    const num = Number(value);
    if (rounding === "round") {
      showValue = round(num, precision, trailingZeroes, thousandSeparator);
    }
    if (rounding === "truncate") {
      showValue = truncate(num, precision, trailingZeroes, thousandSeparator);
    }
  }
  return (
    <span
      className={cn({ "wbuc-text-[#3b65ee]": changed && showChanged })}
      {...rest}
    >
      {showValue}
    </span>
  );
}
